// constants
import { REACT_IDENTIFIER, NYKAA_DTM_STORE_KEY } from './constants';

// defs
import { ITask } from './types';

export const getReactAppType = () => {
  if (
    matchMedia('(display-mode: standalone)').matches /* Android and iOS 11.3+*/ ||
    ('standalone' in navigator && navigator.standalone === true) /* useful for iOS < 11.3*/
  ) {
    return REACT_IDENTIFIER.STANDALONE;
  }

  return REACT_IDENTIFIER.BROWSER;
};

export const isDev = process.env.NODE_ENV === 'development';

export const storeTasks = (tasks: ITask[]) => {
  try {
    window.sessionStorage.setItem(NYKAA_DTM_STORE_KEY, JSON.stringify(tasks));
  } catch (e) {
    /** DO NOTHING */
  }
};

export const clearTasks = () => {
  try {
    window.sessionStorage.removeItem(NYKAA_DTM_STORE_KEY);
  } catch (e) {
    /** DO NOTHING */
  }
};

export const getStoredTasks = (): ITask[] => {
  try {
    const savedData = window.sessionStorage.getItem(NYKAA_DTM_STORE_KEY);

    if (!savedData) {
      return [];
    }

    return JSON.parse(savedData);
  } catch (e) {
    /** DO NOTHING */
    return [];
  }
};
